<template>
  <div class="content-wrapper">
    <div class="content">
      <h1 class="my-anim">
        {{ label }}
      </h1>

      <div
        class="notification"
        :class="{ 'is-danger': isDanger, 'is-primary': isPrimary }"
      >{{ getExplanation }}</div>

      <div v-if="question['DigQuestion']">
        <div class="section-answer accordion">
          <div @click="openAccordion" class="accordion-title">
            <h2>
              <svg
                class="small-icon"
                fill="#0083b3"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 21.086 21.085"
              >
                <path
                  d="M20.53 11.713H.556a.572.572 0 00-.556.588v2.343a.572.572 0 00.556.585H20.53a.572.572 0 00.556-.585v-2.343a.572.572 0 00-.556-.588z"
                />
                <path
                  d="M20.53 5.856H.556A.572.572 0 000 6.441v2.343a.572.572 0 00.556.588H20.53a.572.572 0 00.556-.588V6.441a.572.572 0 00-.556-.585z"
                />
                <path
                  d="M20.53 0H.556A.569.569 0 000 .585v2.343a.569.569 0 00.556.585H20.53a.569.569 0 00.556-.585V.585A.569.569 0 0020.53 0z"
                />
                <path
                  d="M13.092 17.572H.528a.561.561 0 00-.527.585v2.345a.561.561 0 00.527.585h12.564a.561.561 0 00.527-.585v-2.345a.561.561 0 00-.527-.585z"
                />
              </svg>
              {{ question["DigQuestion"] }}
            </h2>
          </div>
          <div class="accordion-content">
            <div class="inner notification">
              {{ question["DigAnswer"] }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="question['MoreLabel']">
        <div class="section-answer link-wrapper">
          <a target="_blank" rel="noopener" :href="question['MoreURL']">
            <h2>
              <svg
                class="small-icon"
                fill="#0083b3"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 21.086 21.089"
              >
                <path
                  d="M20.55.011h-8.256a.534.534 0 00-.534.534V2.68a.534.534 0 00.534.534h3.325L8.678 9.901a.534.534 0 000 .761l1.508 1.51a.534.534 0 00.75 0l6.946-6.7v3.2a.534.534 0 00.534.534h2.135a.534.534 0 00.534-.534V.545a.534.534 0 00-.536-.534z"
                />
                <path
                  d="M20.553 12.019h-2.135a.518.518 0 00-.534.5v5.388H3.19V3.202h5.385a.518.518 0 00.5-.534V.53a.518.518 0 00-.5-.534H.504a.48.48 0 00-.336.139L.152.148.139.164A.48.48 0 000 .5v20.098a.491.491 0 00.139.336l.013.016h.016a.48.48 0 00.336.139h20.075a.491.491 0 00.339-.133l.016-.016a.488.488 0 00.136-.336v-8.08a.518.518 0 00-.517-.505z"
                />
              </svg>
              {{ question["MoreLabel"] }}
            </h2>
          </a>
        </div>
        <div class="section-answer link-wrapper" v-if="question['MoreURL2']">
          <a target="_blank" rel="noopener" :href="question['MoreURL2']">
            <h2>
              <svg
                class="small-icon"
                fill="#0083b3"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 21.086 21.089"
              >
                <path
                  d="M20.55.011h-8.256a.534.534 0 00-.534.534V2.68a.534.534 0 00.534.534h3.325L8.678 9.901a.534.534 0 000 .761l1.508 1.51a.534.534 0 00.75 0l6.946-6.7v3.2a.534.534 0 00.534.534h2.135a.534.534 0 00.534-.534V.545a.534.534 0 00-.536-.534z"
                />
                <path
                  d="M20.553 12.019h-2.135a.518.518 0 00-.534.5v5.388H3.19V3.202h5.385a.518.518 0 00.5-.534V.53a.518.518 0 00-.5-.534H.504a.48.48 0 00-.336.139L.152.148.139.164A.48.48 0 000 .5v20.098a.491.491 0 00.139.336l.013.016h.016a.48.48 0 00.336.139h20.075a.491.491 0 00.339-.133l.016-.016a.488.488 0 00.136-.336v-8.08a.518.518 0 00-.517-.505z"
                />
              </svg>
              {{ question["MoreLabel"] }}
            </h2>
          </a>
        </div>
      </div>

      <button
        @click="submit"
        tag="button"
        class="button button-text button-theme"
      >
        {{ nextLabel }}
      </button>
      <div class="link-wrapper">
        <a class="link" href="#" @click="previous" v-if="quiz > 1"
          >Question précédente</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import AnswerMixin from "./../mixins/AnswerMixin";
import SessionMixin from "./../mixins/SessionCookieMixin";

import Questions from "./../questions";
import Answers from "./../answers";
// import Anime from "animejs/lib/anime.es.js";
import bus from "./../bus";

export default {
  mixins: [AnswerMixin, SessionMixin],
  data() {
    return {
      quiz: null,
      found: false,
      explanation: "",
      question: "",
      session_id: null,
      falseAnswers: ["Dommage :(", "Non...", "Faux", "Nope :/"],
      correctAnswers: ["Bravo!", "Yes :D", "Vrai!", "Joli :P", "Ouiiii"],
      isPrimary: false,
      isDanger: false,
      resultat: "",
      color: "",
      theme: "",
      nextLabel: "Question suivante",
      truefalse: this.$route.params.truefalse == 'true',
    };
  },
  computed: {
    getExplanation: function() {
      if(this.question["Explanation2"]) {
        if (this.truefalse  ) {
          return this.question["Explanation"]
        } else {
          return this.question["Explanation2"]
        }

      } else {
        return this.question["Explanation"]
      }
    },
    randomAnswer: function () {
      if (this.isDanger) {
        return this.falseAnswers[
          Math.floor(Math.random() * this.falseAnswers.length)
        ];
      } else {
        return this.correctAnswers[
          Math.floor(Math.random() * this.correctAnswers.length)
        ];
      }
    },
    env() {
      return process.env;
    },
    quizMax() {
      return this.env.VUE_APP_NB_QUIZ;
    },
    label() {
      const vraiFaux = this.truefalse ? "Vrai" : "Faux";
      let answers = Answers[this.quiz];
      if (typeof answers != "undefined") {
        let ans = answers.find((ans) => ans["Vrai/faux"] == vraiFaux);
        return ans["Label"];
      }
      return "";
    },
  },

  methods: {
    submit() {
      const vm = this;
      if (this.quiz > process.env.VUE_APP_NB_QUIZ) {
        vm.$router.push({ name: "Final" });
        return;
      } else {
        vm.next(this.quiz);
        vm.$router.push({ name: "Prior" });
      }
    },
    previous() {
      let session = this.$cookies.get("bci_session");
      session["Quiz"] = this.quiz - 1;
      session["Answered"] = 0;
      this.$cookies.set("bci_session", session);
      this.$router.push({ name: "Prior" });
    },
    runAnimation() {
      // var btns = Array.from(this.$el.querySelectorAll(".my-anim"));
      // console.log(btns);
      // Anime(
      //   {
      //     targets: btns,
      //     translateY: [-60, 0],
      //     opacity: [0, 1],
      //     duration: 1000,
      //     delay: Anime.stagger(200),
      //   },
      //   "-=1000"
      // );
    },
    openAccordion() {
      let accordionTrigger = document.querySelector(".accordion-title");
      let accordionContent = document.querySelector(".accordion-content");
      accordionTrigger.classList.toggle("active");
      accordionContent.classList.toggle("active");
    },

  },


  mounted() {
    this.runAnimation();
    window.history.forward(1);
    const vm = this;
    // const truefalse = this.$route.params.truefalse;

   
      (this.isPrimary = this.truefalse === "true"),
      (this.isDanger = this.truefalse === "false"),
      (this.resultat = this.truefalse === "true" ? "Juste" : "Faux");

    // Fetch session from cookies
    const record = this.fetchSession();

    const quiz = record["Quiz"];
    vm.found = true;
    vm.quiz = quiz;
    vm.nextLabel =
      quiz >= process.env.VUE_APP_NB_QUIZ
        ? "Terminer le Quiz"
        : "Question Suivante";

    const question = Questions[quiz];
    vm.question = question;
    vm.explanation = question["Explanation"];
    vm.color = question["Color"];
    vm.theme = question["Theme"];

    // preload next images
    if (quiz >= this.quizMax) {
      return;
    }
    const preload = Questions[quiz + 1];
    // const images = preload["Images"] || [];
    const pixelRatio = window.devicePixelRatio;
    const width = screen.width;
    let size = "";
    if (width <= 780) {
      if (pixelRatio == 1) {
        size = "420x";
      } else {
        size = "840x";
      }
    } else if (width > 780 && width <= 1600) {
      if (pixelRatio == 1) {
        size = "700x";
      } else {
        size = "1400x";
      }
    } else {
      if (pixelRatio == 1) {
        size = "1180x";
      } else {
        size = "2360x";
      }
    }

    // images.forEach(function (image) {
    //   let imageP = new Image();
    //   console.log(image, size);
    //   imageP.src = vm.imageproxy("/" + image, size);
    // });
  },
};
</script>
